<template>
  <vs-row class="mt-4">
    <div
      v-for="(filter, index) in filterTypes"
      :key="index"
      class="vx-col w-1/2"
      style="padding-right: 0.375rem"
    >
      <todo-filter-card
        :filter="filter.filter"
        :name="filter.name"
        :color="filter.color"
        :icon="filter.icon"
      />
    </div>
  </vs-row>
</template>

<script>
import TodoFilterCard from "./TodoFilterCard.vue";
import { mapGetters } from "vuex";
export default {
  name: "TodoFilterCards",
  components: { TodoFilterCard },

  props: ["todo"],
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      filterTypes: "personalTodos/filterTypes",
    }),
  },
  mounted() {},
  beforeDestroy: function () {},
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>